export const pdProductCarousalStyles = {
    '.pd-product-carousal-container': {
        px: {
            base: '4',
            sm: '8',
            lg: '16'
        },
        maxW: {
            base: '100%',
            lg: '1920px'
        },
        mx: 'auto',
        '.slick-arrow': {
            zIndex: 1,
            top: '-70px'
        },
        '.slick-next:before, .slick-prev:before': {
            content: 'none'
        },
        '.slick-slider': {
            alignItems: 'center',
            position: 'relative'
        },
        '.slick-slide': {
            mr: '4'
        },
        '.slick-track': {
            display: 'flex'
        },
        '.slick-list': {
            overflow: 'hidden'
        },
        '.slick-disabled': {
            opacity: '0.5'
        },
        '.recommenderHeading': {
            textAlign: 'left',
            color: 'black',
            fontSize: {base: '2xl', md: '40px'},
            fontWeight: 'extrabold',
            lineHeight: {base: '8', md: '52px'},
            mb: {base: 4, sm: 8},
            height: {base: 'auto', sm: '32px', lg: '52px'}
        },
        '.product-tile-block': {
            padding: {base: '2', md: '8px 8px 0', lg: '8px 12px 0'},
            backgroundColor: '#fff',
            borderRadius: 'lg',
            minWidth: {base: '250px', sm: '160px', md: '175px', xl: '245px', '2xl': '320px'}
        },
        '.slick-dots': {
            display: 'flex',
            textAlign: 'center',
            margin: '10px 0',
            padding: 0,
            listStyle: 'none'
        },
        '.slick-dots li': {
            display: 'inline-block',
            margin: '0 5px'
        },
        '.slick-dots li button': {
            width: 4,
            height: 4,
            padding: 0,
            border: 'none',
            borderRadius: '50%',
            backgroundColor: '#ddd',
            cursor: 'pointer',
            textIndent: '-9999px'
        },
        '.slick-dots li button::before': {
            content: '"•"',
            position: 'absolute',
            fontSize: '6px',
            lineHeight: '20px',
            width: 5,
            height: 5,
            textAlign: 'center',
            opacity: 0.25,
            color: 'black'
        },
        '.slick-dots li.slick-active button': {
            backgroundColor: 'black'
        },
        '.slick-dots li.slick-active button::before': {
            opacity: 0.75
        }
    }
}
